import { Component } from '@angular/core';

@Component({
  templateUrl: './workers.page.html',
})
export class WorkersPageComponent {}
